<template>
  <section class="ON_main_article_area">
    <div class="container">
      <div class="row">
        <div class="col-lg-8">
          <div class="ON_area_title_2">
            <h2 id="latest-title">Latest News</h2>
            <p class="divider"></p>
            <button
              @click="sortBy('category')"
              class="ON_generic_button danger circle more-bttn"
              :style="{ 'background-color': '#ff1857' }"
            >
              Sort by Category
              <span v-if="sort.field == 'category'"
                >({{ sort.desc ? "desc" : "asc" }})</span
              >
            </button>
            <button
              @click="sortBy('addition_time')"
              class="ON_generic_button danger circle more-bttn"
              :style="{ 'background-color': '#e5154e' }"
            >
              Sort by Time
              <span v-if="sort.field == 'addition_time'"
                >({{ sort.desc ? "desc" : "asc" }})</span
              >
            </button>
            <button
              @click="sortBy('title')"
              class="ON_generic_button danger circle more-bttn"
              :style="{ 'background-color': '#cc1345' }"
            >
              Sort by Title
              <span v-if="sort.field == 'title'"
                >({{ sort.desc ? "desc" : "asc" }})</span
              >
            </button>
            <button
              @click="sortBy('id')"
              class="ON_generic_button danger circle more-bttn"
              :style="{ 'background-color': '#b2103c' }"
            >
              Sort by Magic
              <span v-if="sort.field == 'id'"
                >({{ sort.desc ? "desc" : "asc" }})</span
              >
            </button>
          </div>
          <div class="ON_latest_news">
            <div
              class="media"
              v-for="article in sortedDataNewsFeed.slice(0, endIteration)"
              :key="article.id"
            >
              <div class="d-flex news-item">
                <router-link
                  :to="{
                    name: 'articles',
                    params: {
                      id: article.id
                    }
                  }"
                  class="ON_cat_button"
                  :style="{ background: '#996515' }"
                  ><img
                    class="img-custom"
                    img
                    :src="article.image"
                    alt=""
                    width="250"
                    height="150"
                /></router-link>
              </div>
              <div class="media-body">
                <div class="ON_article_card_text">
                  <div class="date">
                    <router-link
                      :to="{
                        name: 'articles',
                        params: {
                          id: article.id
                        }
                      }"
                      class="ON_cat_button"
                      :style="{ background: '#996515' }"
                      >{{ article.category }}</router-link
                    >
                    <router-link
                      :to="{
                        name: 'articles',
                        params: {
                          id: article.id
                        }
                      }"
                      ><i class="fa fa-calendar" aria-hidden="true"></i
                      >{{ convertEpoch(article.addition_time) }}</router-link
                    >
                  </div>
                  <router-link
                    :to="{
                      name: 'articles',
                      params: {
                        id: article.id
                      }
                    }"
                    v-scroll-to="{ el: '#topOfPage' }"
                    ><h4>
                      {{ article.title }}
                    </h4></router-link
                  >
                  <p>
                    {{ toolTipText(article.summary) }}
                  </p>
                </div>
                <hr />
              </div>
            </div>
          </div>
          <div id="show-more-wrapper" class="row">
            <div class="column">
              <button
                @click="
                  addToScroll(
                    sortedDataNewsFeed[endIteration - 1].addition_time
                  )
                "
                class="ON_generic_button danger circle more-bttn"
                id="more-bttn"
              >
                Show more
              </button>
            </div>
            <div class="column filler" v-if="endIteration !== 20"></div>
            <div class="column" v-if="endIteration !== 20">
              <button
                @click="removeFromScroll"
                class="ON_generic_button danger circle more-bttn"
                v-scroll-to="{ el: '#more-bttn' }"
              >
                Show less
              </button>
            </div>
          </div>
        </div>
        <div class="col-lg-4">
          <div class="ON_right_side_column">
            <aside class="ON_right_items ON_articles_stream">
              <div class="ON_area_title_2">
                <h2>Emerging News</h2>
              </div>

              <div class="ON_article_slider">
                <div
                  class="item"
                  v-for="article in emergingNews"
                  :key="article.id"
                >
                  <div class="ON_article_item">
                    <router-link
                      :to="{
                        name: 'emerging',
                        params: {
                          id: article.id
                        }
                      }"
                      class="ON_cat_button"
                      :style="{ background: '##40E0D0' }"
                      ><img
                        class="img-custom"
                        img
                        :src="article.image"
                        alt=""
                        width="200"
                        height="100"
                    /></router-link>
                    <div class="ON_article_card_text">
                      <div class="date">
                        <router-link
                          :to="{
                            name: 'emerging',
                            params: {
                              id: article.id
                            }
                          }"
                          class="ON_cat_button"
                          v-scroll-to="{ el: '#topOfPage' }"
                          :style="{ background: '#40E0D0' }"
                          >{{ article.category }}</router-link
                        >
                        <router-link
                          :to="{
                            name: 'emerging',
                            params: {
                              id: article.id
                            }
                          }"
                          v-scroll-to="{ el: '#topOfPage' }"
                          ><i class="fa fa-calendar" aria-hidden="true"></i
                          >{{
                            convertEpoch(article.addition_time)
                          }}</router-link
                        >
                      </div>
                      <router-link
                        :to="{
                          name: 'emerging',
                          params: {
                            id: article.id
                          }
                        }"
                        v-scroll-to="{ el: '#topOfPage' }"
                        ><h4>
                          {{ article.title }}
                        </h4></router-link
                      >

                      <hr />
                    </div>
                  </div>
                </div>
              </div>
            </aside>
            <aside class="ON_right_items ON_ad_items text-center"></aside>
            <aside class="ON_right_items ON_socials_aside">
              <div class="ON_area_title_2">
                <h2>Social Networks</h2>
              </div>
              <ul class="list">
                <li>
                  <a
                    href="https://www.facebook.com/Objective-News-102027294866444/"
                    target="_blank"
                    ><i class="fa fa-facebook"></i>Facebook
                    <span>Like our page</span></a
                  >
                </li>
                <li>
                  <a href="https://twitter.com/ONews_Official" target="_blank"
                    ><i class="fa fa-twitter"></i>Twitter
                    <span>Follow Us</span></a
                  >
                </li>
                <li>
                  <a
                    href="https://www.instagram.com/objectivenews_official/"
                    target="_blank"
                    ><i class="fa fa-instagram"></i>Instagram
                    <span>Subscribe</span></a
                  >
                </li>
              </ul>
              <link
                href="https://fonts.googleapis.com/css?family=Lato&subset=latin,latin-ext"
                rel="stylesheet"
              /><a
                class="bmc-button"
                target="_blank"
                href="https://www.buymeacoffee.com/objectiveNews"
                ><img
                  src="https://cdn.buymeacoffee.com/buttons/bmc-new-btn-logo.svg"
                  alt="Buy us a coffee"
                /><span style="margin-left:5px;font-size:19px !important;"
                  >Buy us a coffee</span
                ></a
              >
            </aside>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import db from "@/fb";
import { toolTipText } from "../toolTipText.js";
import { convertEpoch } from "../convertEpoch.js";

export default {
  mixins: [toolTipText, convertEpoch],
  computed: {
    sortedDataNewsFeed() {
      if (!this.sort.field) {
        return this.news_feed;
      }

      return this.news_feed.concat().sort((a, b) => {
        if (this.sort.desc) {
          return a[this.sort.field] > b[this.sort.field] ? -1 : 1;
        } else {
          return a[this.sort.field] > b[this.sort.field] ? 1 : -1;
        }
      });
    }
  },
  data() {
    return {
      news_feed: [],
      emergingNews: [],
      sort: {
        field: "",
        desc: true
      },
      sport: "#f8b600",
      business: "#4cd3e3",
      politics: "#38a4ff",
      tech: "#f4e700",
      entertainment: "#f44a40",
      endIteration: 20
    };
  },
  methods: {
    addToScroll(startAtPosition) {
      db.collection("articles")
        .orderBy("addition_time", "desc")
        .startAfter(startAtPosition)
        .limit(20)
        .onSnapshot(res => {
          const changes = res.docChanges();

          changes.forEach(change => {
            if (change.type === "added") {
              this.news_feed.push({
                ...change.doc.data(),
                id: change.doc.id
              });
            }
          });
        });
      this.endIteration += 20;
    },
    removeFromScroll() {
      this.endIteration -= 20;
    },
    sortBy(field) {
      if (field == this.sort.field) {
        this.sort.desc = !this.sort.desc;
      } else {
        this.sort.field = field;
        this.sort.desc = true;
      }
    }
  },
  created() {
    db.collection("articles")
      .orderBy("addition_time", "desc")
      .limit(20)
      .onSnapshot(res => {
        const changes = res.docChanges();

        changes.forEach(change => {
          if (change.type === "added") {
            this.news_feed.push({
              ...change.doc.data(),
              id: change.doc.id
            });
          }
        });
      });
    db.collection("emerging")
      .orderBy("addition_time", "desc")
      .limit(10)
      .onSnapshot(res => {
        const changes = res.docChanges();

        changes.forEach(change => {
          if (change.type === "added") {
            this.emergingNews.push({
              ...change.doc.data(),
              id: change.doc.id
            });
          }
        });
      });
    document.title = "ON";
  }
};
</script>
